export const categoryProps={
  checkStrictly: true,
  label:'kindName',
  value:'kindId',
}
